// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__2lvAJ","subheader":"ReorderModal_subheader__3OlkK","listWrap":"ReorderModal_listWrap__CdI8T"};